"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCalendarLink = void 0;
var ADD_EVENT_ID = 'aypbtNBcPzBIdDvukmvT46093';
var TIMEZONE = 'Europe/Amsterdam';

var createDateTime = function createDateTime(isoDateWithoutTime, time) {
  var d = new Date(isoDateWithoutTime); // get date always in original time zone

  d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000);
  var yyyy = d.getFullYear();
  var mm = d.getMonth() + 1;
  var dd = d.getDate();
  return "".concat(yyyy, "-").concat(mm, "-").concat(dd).concat(time ? " ".concat(time) : '');
};

var createEventTitle = function createEventTitle(speaker, talk, eventName) {
  try {
    return "".concat(speaker.name, " - \"").concat(talk.title, "\"").concat(eventName ? " at ".concat(eventName) : '');
  } catch (err) {
    return eventName;
  }
};

var createCalendarLink = function createCalendarLink(speaker, _ref) {
  var calendarEventDescription = _ref.calendarEventDescription,
      calendarEventName = _ref.calendarEventName,
      conferenceStart = _ref.conferenceStart,
      conferenceEnd = _ref.conferenceEnd;

  try {
    var talk = speaker.activities && speaker.activities.talks[0];
    var start = createDateTime(talk.isoDate, talk.time);
    var title = createEventTitle(speaker, talk, calendarEventName);
    return "https://www.addevent.com/dir/?client=".concat(ADD_EVENT_ID, "&start=").concat(start, "&duration=").concat(talk.duration, "&title=").concat(title).concat(calendarEventDescription ? "&description=".concat(calendarEventDescription) : '', "&timezone=").concat(TIMEZONE, "&alarm=15");
  } catch (err) {
    // Fallback whole day event
    if (calendarEventName && conferenceStart && conferenceEnd) {
      var _start = createDateTime(conferenceStart);

      var end = createDateTime(conferenceEnd);
      return "https://www.addevent.com/dir/?client=".concat(ADD_EVENT_ID, "&start=").concat(_start, "&end=").concat(end, "&title=").concat(calendarEventName).concat(calendarEventDescription ? "&description=".concat(calendarEventDescription) : '', "&timezone=").concat(TIMEZONE, "&all_day_event=true");
    }

    return null;
  }
};

exports.createCalendarLink = createCalendarLink;